export const rankBadgeColors: Record<number, string> = {
  1: '#BB8C23',
  2: '#254699',
  3: '#A1C490',
}
